// extracted by mini-css-extract-plugin
export default {"diffStatesWrapper":"PullRequestHeader-module__diffStatesWrapper--fPApA","PreviewLabel":"PullRequestHeader-module__PreviewLabel--kauC0"};